const anonymous = true // 登录鉴权元信息
const requiresAuth = true // 身份验证元信息
const keepAlive = true // keep-alive 缓存
const K12_Routes = {
  path: '/k12/:group',
  name: 'k12Frame',
  props: true,
  component: () => import('@components/Frame.vue'),
  meta: { anonymous, requiresAuth },
  children: [
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——本机构信息
       */
      path: 'currentOrg',
      component: () => import('/src/views/k12/base/currentOrg/index.vue'),
      breadcrumbName: '本机构信息',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——本机构信息-> 编辑机构信息
       */
      path: 'currentOrg/edit/:orgId',
      component: () => import('/src/views/k12/base/currentOrg/edit.vue'),
      props: true,
      breadcrumbName: '编辑机构信息',
      meta: { requiresAuth, funPath: '/k12/base/currentOrg' }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——设备管理
       */
      path: 'device',
      component: () => import('/src/views/k12/base/device/index.vue'),
      breadcrumbName: '设备管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——场所管理
       */
      path: 'place',
      component: () => import('/src/views/k12/base/place/index.vue'),
      breadcrumbName: '场所管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——场所管理->管理设备
       */
      path: 'place/device/:id',
      component: () => import('/src/views/k12/base/place/device.vue'),
      props: true,
      breadcrumbName: '关联设备',
      meta: { requiresAuth, funPath: '/k12/base/place' }
    },
    {
      /**
       * @description: 基础管理——机构管理——学期学年
       */
      path: 'org/acayear',
      component: () => import('/src/views/k12/base/org/acayear/index.vue'),
      props: true,
      breadcrumbName: '学年学期',
      meta: { funPath: '/k12/base/org', keepAlive }
    },
    {
      /**
       * @description: 基础管理——机构管理——学期学年——新增编辑
       */
      path: 'org/acayear/add',
      component: () => import('/src/views/k12/base/org/acayear/addOrEdit.vue'),
      props: true,
      breadcrumbName: '新增学年',
      meta: { requiresAuth, funPath: '/k12/base/org' }
    },
    {
      /**
       * @description: 基础管理——机构管理——学期学年——编辑
       */
      path: 'org/acayear/edit',
      component: () => import('/src/views/k12/base/org/acayear/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑学年',
      meta: { requiresAuth, funPath: '/k12/base/org' }
    },
    {
      /**
       * @description: 基础管理——机构管理——学级管理
       */
      path: 'org/grade',
      component: () => import('/src/views/k12/base/org/grade/index.vue'),
      props: true,
      breadcrumbName: '入学年份',
      meta: { requiresAuth, funPath: '/k12/base/org', keepAlive }
    },
    {
      /**
       * @description: 基础管理——机构管理——班级管理
       */
      path: 'org/class',
      component: () => import('/src/views/k12/base/org/class/index.vue'),
      props: true,
      breadcrumbName: '班级管理',
      meta: { requiresAuth, funPath: '/k12/base/org', keepAlive }
    },
    // {
    //   /**
    //    * @description: 基础管理——机构管理——班级管理——新增编辑
    //    */
    //   path: 'org/class/add',
    //   component: () => import('/src/views/k12/base/org/class/addOrEdit.vue'),
    //   props: true,
    //   breadcrumbName: '班级管理',
    //   meta: { requiresAuth, funPath: '/k12/base/org' }
    // },
    // {
    //   /**
    //    * @description: 基础管理——机构管理——班级管理——新增编辑
    //    */
    //   path: 'org/class/edit/:classId',
    //   component: () => import('/src/views/k12/base/org/class/addOrEdit.vue'),
    //   props: true,
    //   breadcrumbName: '班级管理',
    //   meta: { requiresAuth, funPath: '/k12/base/org' }
    // },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——用户管理——教职工管理
       */
      path: 'user/teacher',
      component: () => import('/src/views/k12/base/user/teacher'),
      breadcrumbName: '教职工',
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——新增用户
       */
      path: 'user/teacher/add',
      component: () => import('/src/views/k12/base/user/teacher/addOrEdit.vue'),
      breadcrumbName: '新增教职工',
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——编辑用户
       */
      path: 'user/teacher/edit/:id',
      component: () => import('/src/views/k12/base/user/teacher/addOrEdit.vue'),
      breadcrumbName: '编辑教职工',
      props: true,
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },

    {
      /**
       * @description: 基础管理——用户管理——学生管理
       */
      path: 'user/student',
      component: () => import('/src/views/k12/base/user/student'),
      breadcrumbName: '学生',
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——新增用户
       */
      path: 'user/student/add',
      component: () => import('/src/views/k12/base/user/student/addOrEdit.vue'),
      breadcrumbName: '新增学生',
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——编辑用户
       */
      path: 'user/student/edit/:id',
      component: () => import('/src/views/k12/base/user/student/addOrEdit.vue'),
      breadcrumbName: '编辑学生',
      props: true,
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },

    {
      /**
       * @description: 基础管理——用户管理——家长管理
       */
      path: 'user/parent',
      component: () => import('/src/views/k12/base/user/parent'),
      breadcrumbName: '家长',
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },
    // {
    //   /**
    //    * @description: 基础管理——用户管理——新增用户
    //    */
    //   path: 'user/parent/add',
    //   component: () => import('/src/views/k12/base/user/parent/addOrEdit.vue'),
    //   breadcrumbName: '新增家长',
    //   meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    // },
    {
      /**
       * @description: 基础管理——用户管理——编辑用户
       */
      path: 'user/parent/edit/:id',
      component: () => import('/src/views/k12/base/user/parent/addOrEdit.vue'),
      breadcrumbName: '编辑家长',
      props: true,
      meta: { requiresAuth, funPath: '/k12/base/user', keepAlive }
    },
    // ---------------------------------------------------------------- //

    {
      /**
       * @description: 基础管理——角色管理
       */
      path: 'role',
      component: () => import('/src/views/k12/base/role/index.vue'),
      breadcrumbName: '角色管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 新增角色
       */
      path: 'role/add',
      component: () => import('/src/views/k12/base/role/addOrEdit.vue'),
      breadcrumbName: '新增角色',
      meta: { requiresAuth, funPath: '/base/role' }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 编辑角色
       */
      path: 'role/edit/:recordUid',
      component: () => import('/src/views/k12/base/role/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑角色',
      meta: { requiresAuth, funPath: '/base/role' }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 管理成员
       */
      path: 'role/members/:id',
      component: () => import('/src/views/k12/base/role/roleMember.vue'),
      props: true,
      breadcrumbName: '管理成员',
      meta: { requiresAuth, funPath: '/base/role', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育测试——组织测试——测试管理
       */
      path: 'organizeTest/testManage',
      component: () => import('/src/views/k12/sportTest/organizeTest/testManage/index.vue'),
      breadcrumbName: '测试管理',
      meta: { requiresAuth, funPath: '/k12/sportTest/organizeTest', keepAlive }
    },
    {
      /**
       * @description: 体育测试——组织测试——测试管理--新增计划
       */
      path: 'organizeTest/testManage/add',
      component: () => import('/src/views/k12/sportTest/organizeTest/testManage/addOrEdit.vue'),
      breadcrumbName: '新增计划',
      meta: { requiresAuth, funPath: '/k12/sportTest/organizeTest' }
    },
    {
      /**
       * @description: 体育测试——组织测试——测试管理--查看计划
       */
      path: 'organizeTest/testManage/check/:id',
      component: () => import('/src/views/k12/sportTest/organizeTest/testManage/checkPlan.vue'),
      props: true,
      breadcrumbName: '查看计划',
      meta: { requiresAuth, funPath: '/k12/sportTest/organizeTest' }
    },
    {
      /**
       * @description: 体育测试——组织测试——成绩查询
       */
      path: 'organizeTest/scoreSearch',
      component: () => import('/src/views/k12/sportTest/organizeTest/scoreSearch/index.vue'),
      breadcrumbName: '成绩查询',
      meta: { requiresAuth, funPath: '/k12/sportTest/organizeTest', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育测试——自主测试——测试记录
       */
      path: 'selfTest/testRecord',
      component: () => import('/src/views/k12/sportTest/selfTest/testRecord/index.vue'),
      breadcrumbName: '测试记录',
      meta: { requiresAuth, funPath: '/k12/sportTest/selfTest', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育锻炼——锻炼记录—— 自由锻炼
       */
      path: 'exerciseRecord/freeExercise',
      component: () => import('/src/views/k12/sportExercise/exerciseRecord/index.vue'),
      breadcrumbName: '自由锻炼',
      meta: { requiresAuth, funPath: '/k12/sportExercise/exerciseRecord', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——锻炼记录——微球场
       */
      path: 'exerciseRecord/microCourt',
      component: () => import('/src/views/k12/sportExercise/exerciseRecord/indexMicroCourt.vue'),
      breadcrumbName: '微球场',
      meta: { requiresAuth, funPath: '/k12/sportExercise/exerciseRecord', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——锻炼记录-- 趣味锻炼
       */
      path: 'exerciseRecord/funExercise',
      component: () => import('/src/views/k12/sportExercise/exerciseRecord/indexFun.vue'),
      breadcrumbName: '趣味锻炼',
      meta: { requiresAuth, funPath: '/k12/sportExercise/exerciseRecord', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——锻炼记录-- 竞技场
       */
      path: 'exerciseRecord/arena',
      component: () => import('/src/views/k12/sportExercise/exerciseRecord/indexArena.vue'),
      breadcrumbName: '竞技场',
      meta: { requiresAuth, funPath: '/k12/sportExercise/exerciseRecord', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育锻炼——统计报表——阳光跑班级报表
       */
      path: 'statisticsReport/sunshineRunClass',
      component: () =>
        import('/src/views/k12/statisticsReport/sunshineRunning/classReport/index.vue'),
      breadcrumbName: '阳光跑班级报表',
      meta: { requiresAuth, funPath: '/k12/statisticsReport', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——统计报表——阳光跑个人报表
       */
      path: 'statisticsReport/sunshineRunPerson',
      component: () =>
        import('/src/views/k12/statisticsReport/sunshineRunning/personReport/index.vue'),
      breadcrumbName: '阳光跑个人报表',
      meta: { requiresAuth, funPath: '/k12/sportExercise/statisticsReport', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛
       */
      path: 'onlineManagement/competitionRank',
      component: () => import('/src/views/k12/sportsGame/onlineManagement/competitionRank'),
      breadcrumbName: '竞技排名赛',
      meta: { requiresAuth, funPath: '/k12/sportsGame/onlineManagement', keepAlive }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 新增竞技排名赛
       */
      path: 'onlineManagement/competitionRank/addRank',
      component: () =>
        import('/src/views/k12/sportsGame/onlineManagement/competitionRank/addOrEdit.vue'),
      breadcrumbName: '新增竞技排名赛',
      meta: { requiresAuth, funPath: '/k12/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 编辑竞技排名赛
       */
      path: 'onlineManagement/competitionRank/editRank/:id',
      component: () =>
        import('/src/views/k12/sportsGame/onlineManagement/competitionRank/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑竞技排名赛',
      meta: { requiresAuth, funPath: '/k12/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 竞技排名赛详情
       */
      path: 'onlineManagement/competitionRank/detailRank/:id',
      component: () =>
        import('/src/views/k12/sportsGame/onlineManagement/competitionRank/addOrEdit.vue'),
      props: true,
      breadcrumbName: '竞技排名赛详情',
      meta: { requiresAuth, funPath: '/k12/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——竞技排名赛-> 竞技排名赛数据
       */
      path: 'onlineManagement/competitionRank/dataRank/:id',
      component: () => import('/src/views/k12/sportsGame/onlineManagement/competitionRankData'),
      props: true,
      breadcrumbName: '竞技排名赛数据',
      meta: { requiresAuth, funPath: '/k12/sportsGame/onlineManagement' }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育教学——体育家庭作业——作业管理
       */
      path: 'sportsHomework/homeworkManagement',
      component: () => import('/src/views/k12/sportsTeach/sportsHomework/homeworkManagement'),
      breadcrumbName: '作业管理',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/sportsHomework', keepAlive }
    },
    {
      /**
       * @description: 体育教学——体育家庭作业——作业管理-> 发布作业
       */
      path: 'sportsHomework/homeworkManagement/add',
      component: () =>
        import('/src/views/k12/sportsTeach/sportsHomework/homeworkManagement/addOrEdit.vue'),
      breadcrumbName: '发布作业',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/sportsHomework' }
    },
    {
      /**
       * @description: 体育教学——体育家庭作业——作业管理-> 详情
       */
      path: 'sportsHomework/homeworkManagement/detail/:id',
      component: () =>
        import('/src/views/k12/sportsTeach/sportsHomework/homeworkManagement/detail.vue'),
      props: true,
      breadcrumbName: '作业详情',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/sportsHomework' }
    },
    {
      /**
       * @description: 体育教学——体育家庭作业——作业管理-> 编辑作业
       */
      path: 'sportsHomework/homeworkManagement/edit/:id',
      component: () =>
        import('/src/views/k12/sportsTeach/sportsHomework/homeworkManagement/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑作业',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/sportsHomework' }
    },
    // ---------------------------------------------------------------- //

    {
      /**
       * @description: 国家学生体质健康测试——体质健康测试管理——测试结果
       */
      path: 'physiqueManage/testResult',
      component: () => import('/src/views/k12/hm/physiqueManage/testResult/index.vue'),
      breadcrumbName: '测试结果',
      meta: { requiresAuth, funPath: '/k12/hm/physiqueManage', keepAlive }
    },
    {
      /**
       * @description: 国家学生体质健康测试——体质健康测试管理——学生档案
       */
      path: 'physiqueManage/studentArchive',
      component: () => import('/src/views/k12/hm/physiqueManage/studentArchive/index.vue'),
      breadcrumbName: '学生档案',
      meta: { requiresAuth, funPath: '/k12/hm/physiqueManage', keepAlive }
    },
    {
      /**
       * @description: 国家学生体质健康测试——体质健康测试管理——测试结果->详情
       */
      path: 'physiqueManage/testResult/editUpReport',
      component: () => import('/src/views/k12/hm/physiqueManage/testResult/upReport.vue'),
      breadcrumbName: '详情',
      meta: { requiresAuth, funPath: '/k12/hm/physiqueManage' }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育教学——体育课堂——随堂练列表
       */
      path: 'class/practise',
      component: () => import('/src/views/k12/sportsTeach/class/practise'),
      props: true,
      breadcrumbName: '随堂练',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/class', keepAlive }
    },
    {
      /**
       * @description: 体育教学——体育课堂——随堂测列表
       */
      path: 'class/test',
      component: () => import('/src/views/k12/sportsTeach/class/test'),
      props: true,
      breadcrumbName: '随堂测',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/class', keepAlive }
    },
    {
      /**
       * @description: 体育教学——体育课堂——随堂赛列表
       */
      path: 'class/match',
      component: () => import('/src/views/k12/sportsTeach/class/match'),
      props: true,
      breadcrumbName: '随堂赛',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/class', keepAlive }
    },

    {
      /**
       * @description: 体育教学——特训——特训列表
       */
      path: 'specialTraining/specialTrainingList',
      component: () => import('/src/views/k12/sportsTeach/specialTraining/specialTrainingList'),
      breadcrumbName: '个性化训练列表',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/specialTraining', keepAlive }
    },
    {
      /**
       * @description: 体育教学——特训——新增
       */
      path: 'specialTraining/specialTrainingList/add',
      component: () => import('/src/views/k12/sportsTeach/specialTraining/training/index.vue'),
      breadcrumbName: '新增个性化训练',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/specialTraining' }
    },
    {
      /**
       * @description: 体育教学——特训——编辑
       */
      path: 'specialTraining/specialTrainingList/detail',
      component: () => import('/src/views/k12/sportsTeach/specialTraining/training/index.vue'),
      breadcrumbName: '查看个性化训练',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/sportsHomework' }
    },
    {
      /**
       * @description: 体育教学——特训——数据列表
       */
      path: 'specialTraining/specialTrainingList/detailDataList',
      component: () => import('/src/views/k12/sportsTeach/specialTraining/specialDataList.vue'),
      breadcrumbName: '数据列表',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/specialTraining' }
    },
    {
      /**
       * @description: 体育教学-备课助手-资源列表
       */
      path: 'lessonAssistant/lessonResourceList',
      component: () =>
        import('/src/views/k12/sportsTeach/lessonAssistant/lessonResourceList/index.vue'),
      breadcrumbName: '资源列表',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/lessonAssistant', keepAlive }
    },
    {
      /**
       * @description: 体育教学-备课助手-新增资源
       */
      path: 'lessonAssistant/lessonResourceList/add',
      component: () =>
        import('/src/views/k12/sportsTeach/lessonAssistant/lessonResourceList/addOrEdit.vue'),
      breadcrumbName: '新增资源',
      meta: { requiresAuth, funPath: '/k12/sportsTeach/lessonAssistant', keepAlive }
    },
    {
      /**
       * @description: 体育教学-备课助手-编辑资源
       */
      path: 'lessonAssistant/lessonResourceList/edit/:id',
      component: () =>
        import('/src/views/k12/sportsTeach/lessonAssistant/lessonResourceList/addOrEdit.vue'),
      breadcrumbName: '编辑资源',
      props: true,
      meta: { requiresAuth, funPath: '/k12/sportsTeach/lessonAssistant', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育赛事——运动会管理——运动会列表
       */
      path: 'sportsMeet',
      component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetList.vue'),
      breadcrumbName: '运动会管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——运动会列表
       */
      path: 'sportsMeet/add',
      component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetListAdd.vue'),
      breadcrumbName: '新增运动会',
      meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet', keepAlive }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——管理-详情
       */
      path: 'sportsMeet/detail',
      component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetDetail.vue'),
      // props: true,
      breadcrumbName: '管理运动会',
      meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet', keepAlive }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——编排
       */
      path: 'sportsMeet/detail/arrange',
      component: () => import('/src/views/k12/sportsGame/sportsMeet/detailArrangeList.vue'),
      // props: true,
      breadcrumbName: '编排',
      meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet' }
    },
    {
      /**
       * @description: 体育赛事——运动会日程表
       */
      path: 'sportsMeet/detail/calendar',
      component: () => import('/src/views/k12/sportsGame/sportsMeet/calendar.vue'),
      // props: true,
      breadcrumbName: '日程表',
      meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet' }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——风采
       */
      path: 'sportsMeet/demeanor/:meetId',
      component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetListDemeanor.vue'),
      props: true,
      breadcrumbName: '运动风采',
      meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育评价-学校画像
       */
      path: 'dataCenter/school',
      component: () => import('/src/views/k12/sportEvaluation/dataCenter/school/index.vue'),
      breadcrumbName: '学校画像',
      meta: { requiresAuth, funPath: '/k12/sportEvaluation/dataCenter', keepAlive }
    },
    {
      /**
       * @description: 体育评价-年级画像
       */
      path: 'dataCenter/grade',
      component: () => import('/src/views/k12/sportEvaluation/dataCenter/grade/index.vue'),
      breadcrumbName: '年级画像',
      meta: { requiresAuth, funPath: '/k12/sportEvaluation/dataCenter', keepAlive }
    },
    {
      /**
       * @description: 体育评价-班级画像
       */
      path: 'dataCenter/class',
      component: () => import('/src/views/k12/sportEvaluation/dataCenter/class/index.vue'),
      breadcrumbName: '班级画像',
      meta: { requiresAuth, funPath: '/k12/sportEvaluation/dataCenter', keepAlive }
    },
    {
      /**
       * @description: 体育评价-班级画像-> 详情
       */
      path: 'dataCenter/class/detail/:id',
      component: () => import('/src/views/k12/sportEvaluation/dataCenter/class/detail.vue'),
      props: true,
      breadcrumbName: '班级详情',
      meta: { requiresAuth, funPath: '/k12/sportEvaluation/dataCenter' }
    },
    {
      /**
       * @description: 体育评价-学生画像
       */
      path: 'dataCenter/student',
      component: () => import('/src/views/k12/sportEvaluation/dataCenter/student/index.vue'),
      breadcrumbName: '学生画像',
      meta: { requiresAuth, funPath: '/k12/sportEvaluation/dataCenter', keepAlive }
    },
    {
      /**
       * @description: 体育评价-学生画像-> 详情
       */
      path: 'dataCenter/student/detail/:id',
      component: () => import('/src/views/k12/sportEvaluation/dataCenter/student/detail.vue'),
      props: true,
      breadcrumbName: '班级详情',
      meta: { requiresAuth, funPath: '/k12/sportEvaluation/dataCenter' }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 运营运维中心-百科管理-校本资源
       */
      path: 'wikiManagement/schoolWiki',
      component: () => import('/src/views/k12/resources/wikiManagement/schoolWiki/index.vue'),
      breadcrumbName: '校本资源',
      meta: { requiresAuth, funPath: '/k12/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-校本资源-新增资源
       */
      path: 'wikiManagement/schoolWiki/add',
      component: () => import('/src/views/k12/resources/wikiManagement/schoolWiki/addOrEdit.vue'),
      breadcrumbName: '新增校本资源',
      meta: { requiresAuth, funPath: '/k12/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-校本资源-编辑资源
       */
      path: 'wikiManagement/schoolWiki/edit/:id',
      component: () => import('/src/views/k12/resources/wikiManagement/schoolWiki/addOrEdit.vue'),
      breadcrumbName: '编辑校本资源',
      props: true,
      meta: { requiresAuth, funPath: '/k12/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-资源分类
       */
      path: 'wikiManagement/ResClassification',
      component: () =>
        import('/src/views/k12/resources/wikiManagement/ResClassification/index.vue'),
      breadcrumbName: '资源分类',
      meta: { requiresAuth, funPath: '/k12/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-资源分类-新增资源分类
       */
      path: 'wikiManagement/ResClassification/add',
      component: () =>
        import('/src/views/k12/resources/wikiManagement/ResClassification/addOrEdit.vue'),
      breadcrumbName: '新增资源分类',
      meta: { requiresAuth, funPath: '/k12/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-资源分类-编辑资源分类
       */
      path: 'wikiManagement/ResClassification/edit/:id',
      component: () =>
        import('/src/views/k12/resources/wikiManagement/ResClassification/addOrEdit.vue'),
      breadcrumbName: '编辑资源分类',
      props: true,
      meta: { requiresAuth, funPath: '/k12/resources/wikiManagement', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 运营运维中心——banner——banner
       */
      path: 'banner/bannerConfig',
      component: () => import('/src/views/k12/resources/banner/index.vue'),
      breadcrumbName: 'Banner配置',
      meta: { requiresAuth, funPath: '/k12/resources/banner', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心——banner—— -> 新增编辑
       */
      path: 'banner/bannerConfig/edit/:uid',
      component: () => import('/src/views/k12/resources/banner/editBanner.vue'),
      props: true,
      breadcrumbName: '编辑Banner配置',
      meta: { requiresAuth, funPath: '/k12/resources/banner' }
    },
    {
      /**
       * @description: 运营运维中心——banner—— -> 查看
       */
      path: 'banner/bannerConfig/detail/:uid',
      component: () => import('/src/views/k12/resources/banner/lookBanner.vue'),
      props: true,
      breadcrumbName: '查看Banner配置',
      meta: { requiresAuth, funPath: '/k12/resources/banner' }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 主页发布管理
       */
      path: 'orgHomepage/homepagePublish',
      component: () => import('/src/views/k12/resources/orgHomepage/homepagePublish/index.vue'),
      breadcrumbName: '主页发布管理',
      meta: { requiresAuth, funPath: '/k12/resources/orgHomepage', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 新增主页发布
       */
      path: 'orgHomepage/homepagePublish/add',
      component: () => import('/src/views/k12/resources/orgHomepage/homepagePublish/addOrEdit.vue'),
      props: true,
      breadcrumbName: '新增主页',
      meta: { requiresAuth, funPath: '/k12/resources/orgHomepage' }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 编辑主页发布
       */
      path: 'orgHomepage/homepagePublish/edit/:id',
      component: () => import('/src/views/k12/resources/orgHomepage/homepagePublish/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑主页',
      meta: { requiresAuth, funPath: '/k12/resources/orgHomepage' }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 分类管理
       */
      path: 'orgHomepage/category',
      component: () => import('/src/views/k12/resources/orgHomepage/category/index.vue'),
      breadcrumbName: '分类管理',
      meta: { requiresAuth, funPath: '/k12/resources/orgHomepage', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 运营运维中心——宣传页管理——宣传页配置
       */
      path: 'promotionPage/promotionConfig',
      component: () => import('/src/views/k12/resources/promotionPage/promotionConfig/index.vue'),
      breadcrumbName: '宣传页配置',
      meta: { requiresAuth, funPath: '/k12/resources/promotionPage', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心——宣传页管理——新增宣传页配置
       */
      path: 'promotionPage/promotionConfig/add',
      component: () => import('/src/views/k12/resources/promotionPage/promotionConfig/addOrEdit.vue'),
      breadcrumbName: '新增宣传页',
      meta: { requiresAuth, funPath: '/k12/resources/promotionPage' }
    },
    {
      /**
       * @description: 运营运维中心——宣传页管理——编辑宣传页配置
       */
      path: 'promotionPage/promotionConfig/edit/:id',
      component: () => import('/src/views/k12/resources/promotionPage/promotionConfig/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑宣传页',
      meta: { requiresAuth, funPath: '/k12/resources/promotionPage' }
    }
  ]
}

export default K12_Routes
